// Default feature flags used as fallback values.
// Used in FirebaseRemoteConfigProvider as default values and in Playwright tests to mock Remote Config fetches.
// Extracted to a standalone file so Playwright tests can import
// without pulling in React component dependencies.

type FeatureFlags = Record<string, boolean>

export const defaultFeatureFlags: FeatureFlags = {
    greenfieldLinkEnabled: true,
    settingsLinkEnabled: true,
    salesLinkEnabled: true,
    assetsProtectionEnabled: true,
    brandsEnabled: true,
    loyaltyEnabled: true,
    notesEnabled: true,
    opsMetricsEnabled: true,
    storeFulfillmentEnabled: true,
    storeInfoEnabled: true,
    trailerEnabled: true,
    shortageEnabled: true,
    payrollEnabled: true,
    safetyEnabled: true,
    itemDetailsEnabled: true,
    nddTabEnabled: true,
    myTargetPerformanceEnabled: true,
    insightsEnabled: false,
    landingPageEnabled: true,
    sortByTimeEnabled: true,
    powerBiEnabled: false,
}
